<template>
    <div id="campanha-listagem">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <h4 class="header2">Listagem de Campanhas</h4>
                            <table class="responsive-table bordered striped">
                                <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Data criaçao</th>
                                    <th class="center">Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in itens">
                                    <td>{{ item.campanha_nome }}</td>
                                    <td>{{ item.data_criacao | formatDate }}</td>
                                    <td class="center">
                                        <router-link
                                            :to="'/campanha/clientes/'+item.campanha_id"
                                            class="btn-floating waves-effect waves-light gradient-45deg-indigo-light-blue gradient-shadow"
                                            v-tooltip.top="'Ver os clientes da campanha'"
                                        >
                                            <i class="material-icons">account_circle</i>
                                        </router-link>
                                        <router-link :to="'/campanha/'+item.campanha_id" class="btn-floating waves-effect waves-light gradient-45deg-amber-amber gradient-shadow">
                                            <i class="material-icons">mode_edit</i>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
        <div class="fixed-action-btn active" style="bottom: 50px; right: 19px;">
            <router-link to="/campanha/cadastro" class="btn-floating btn-large btn-default">
                <i class="material-icons">add</i>
            </router-link>
        </div>
    </div>
</template>
<script>
    import { get } from '@/helpers/api';
    import BotaoRemover from '@/components/common/BotaoRemover';

    export default {
        components: {
            BotaoRemover
        },
        data: () => ({
            itens: []
        }),
        created() {
            let self = this;
            get('campanha').then(function (response) {
                self.itens = response.data.result.data;
            })
        },
        methods: {
            save() {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/campanha/Listagem.vue